import router from "../../router";
import { axiosInstance as axios } from "../Editor/services/axios-provider";

export default class MaintenanceInterceptor {
  constructor() {}
  public enable() {
    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        if (error.response.status === 503) {
          router.push({ name: "MaintenanceComponentVue" });
        }
        return Promise.reject(error);
      }
    );
  }
}
